import { render, staticRenderFns } from "./SharedDocs.vue?vue&type=template&id=aca8da04&"
import script from "./SharedDocs.vue?vue&type=script&lang=js&"
export * from "./SharedDocs.vue?vue&type=script&lang=js&"
import style0 from "./SharedDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports